import { useTheme } from '../../../../../../hooks/useTheme';
import styles from '../Fetch.module.css';
import { FetchOfferBar } from './FetchOfferBar';
import type { FetchQuoteFailure } from '../fetchQuote';

interface FetchErrorProps {
  onBack: () => void;
  message?: string;
  failure?: FetchQuoteFailure;
  isMobile?: boolean;
}

// Fetch never says why it refused, so this names the field to check rather than
// declaring the zip wrong.
const FAILURE_MESSAGES: Record<FetchQuoteFailure, string> = {
  address:
    "We couldn't get a quote for that address. Check your ZIP code and try again.",
  unknown: 'Something went wrong — try again.',
};

export function FetchError({
  onBack,
  message,
  failure = 'unknown',
  isMobile,
}: FetchErrorProps) {
  const theme = useTheme();
  const rootClass = isMobile
    ? `${styles.petScreen} ${styles.mobile}`
    : styles.petScreen;

  return (
    <div
      className={rootClass}
      style={{ fontFamily: theme.bodytextDefaultNone?.fontFamily }}
    >
      {!isMobile && <FetchOfferBar />}
      <div className={styles.loadingBody}>
        <p className={styles.loadingText}>
          {message ?? FAILURE_MESSAGES[failure]}
        </p>
        <button type="button" className={styles.successBack} onClick={onBack}>
          Back
        </button>
      </div>
    </div>
  );
}
